import { TagPicker } from '@fluentui/react';
import { Label } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';

export class PickerNumber extends Component {

    static defaultProps = {
        autoComplete: "off",
        disabled: false,
        label: "Numbers",
        onChange: (numbers) => null,
        required: false,
        numbers: [],
    };

    constructor(props) {
        super(props);
        this.numbers = [];
        this.state = { appendedNumbers: "" };
    };

    _onBlur = () => {
        const numbersToAppend = this.state.appendedNumbers
            .toLowerCase()
            .split(";")
            .map(number => number.trim())
            .filter(Boolean); // Suppression des valeurs nulles

        if (numbersToAppend.length > 0) {
            let correctNumbers = [...this.props.numbers];
            let incorrectNumbers = [];
            numbersToAppend.forEach((number, index) => {
                if (!isNaN(number)) correctNumbers.push(parseInt(number));
                else incorrectNumbers.push(number);
            });
            this.setState(
                { appendedNumbers: incorrectNumbers.join(";") },
                () => this.props.onChange(Array.from(new Set(correctNumbers)))
            )
        }
    };

    _onChange = (items) => {
        this.props.onChange(items.map(item => item.key))
    };

    _onInputChange = (input) => {
        this.setState({ appendedNumbers: input.trim() });
        return input.trim();
    };

    render = () => {
        const { disabled, numbers, label, required } = this.props;
        const { appendedNumbers } = this.state;
        const styles = disabled ? { input: { display: "none" } } : {};

        return <Fragment>
            <Label required={required} disabled={disabled}>{label}</Label>
            <TagPicker
                disabled={disabled}
                inputProps={{ value: appendedNumbers || " " }} // Espace ; bypass un bug de FluentUI qui ne rerender pas correctement l'input s'il est vide
                onBlur={this._onBlur}
                onChange={this._onChange}
                onInputChange={this._onInputChange}
                onResolveSuggestions={(filter, selectedItems) => []}
                selectedItems={numbers.filter(number => !!number).map(number => ({ key: number, name: number }))}
                styles={styles}
            />
        </Fragment>;
    };

}